/* Certification Error Module */
import { FeatureError } from '@/libs/errors/FeatureError';
import { T } from '@/libs/translation';

/** @description 인증번호 요청 데이터가 잘못됨 */
export const CERTIFICATION_001 = (error?: Error) =>
  new FeatureError(
    {
      title: T('certification.error.mobile.001_title'),
      message: T('certification.error.mobile.001_message'),
      code: 'CERTIFICATION_001',
      priority: 3,
    },
    error,
  );

/** @description 인증번호 요청시 요청 데이터와 일치하는 user가 존재하지 않음 */
export const CERTIFICATION_002 = (error?: Error) =>
  new FeatureError(
    {
      title: T('certification.error.mobile.002_title'),
      message: T('certification.error.mobile.002_message'),
      code: 'CERTIFICATION_002',
    },
    error,
  );

/** @description 인증번호 확인 데이터가 잘못됨 */
export const CERTIFICATION_003 = (error?: Error) =>
  new FeatureError(
    {
      title: T('certification.error.mobile.003_title'),
      message: T('certification.error.mobile.003_message'),
      code: 'CERTIFICATION_003',
      priority: 3,
    },
    error,
  );

/** @description 인증번호 만료 또는 불일치 */
export const CERTIFICATION_004 = (error?: Error) =>
  new FeatureError(
    {
      title: T('certification.error.mobile.004_title'),
      message: T('certification.error.mobile.004_message'),
      code: 'CERTIFICATION_004',
    },
    error,
  );

/** @description 인증번호를 통해 이메일을 찾는 중 인증 요청 확인 데이터가 잘못됨 */
export const CERTIFICATION_005 = (error?: Error) =>
  new FeatureError(
    {
      title: T('certification.error.mobile.005_title'),
      message: T('certification.error.mobile.005_message'),
      code: 'CERTIFICATION_005',
      priority: 10,
    },
    error,
  );

/** @description 인증 완료된 인증 데이터가 존재하지 않거나 인증 유효 시간이 만료됨 */
export const CERTIFICATION_006 = (error?: Error) =>
  new FeatureError(
    {
      title: T('certification.error.mobile.006_title'),
      message: T('certification.error.mobile.006_message'),
      code: 'CERTIFICATION_006',
      priority: 3,
    },
    error,
  );

/** @description 인증번호를 통해 이메일을 찾는 중 요청 데이터와 일치하는 user가 존재하지 않음 */
export const CERTIFICATION_007 = (error?: Error) =>
  new FeatureError(
    {
      title: T('certification.error.mobile.007_title'),
      message: T('certification.error.mobile.007_message'),
      code: 'CERTIFICATION_007',
      priority: 3,
    },
    error,
  );

/** @description 인증번호를 통해 비밀번호를 재설정하는 중 요청 데이터가 잘못됨 */
export const CERTIFICATION_008 = (error?: Error) =>
  new FeatureError(
    {
      title: T('certification.error.mobile.008_title'),
      message: T('certification.error.mobile.008_message'),
      code: 'CERTIFICATION_008',
      priority: 10,
    },
    error,
  );

/** @description 인증번호를 통해 비밀번호를 재설정하는 중 user가 존재하지 않음 */
export const CERTIFICATION_009 = (error?: Error) =>
  new FeatureError(
    {
      title: T('certification.error.mobile.009_title'),
      message: T('certification.error.mobile.009_message'),
      code: 'CERTIFICATION_009',
      priority: 10,
    },
    error,
  );

/** @description 이메일 변경 인증 요청 중 기존 이메일과 동일한 이메일을 요청함 */
export const CERTIFICATION_010 = (error?: Error) =>
  new FeatureError(
    {
      title: T('certification.error.mobile.010_title'),
      message: T('certification.error.mobile.010_message'),
      code: 'CERTIFICATION_010',
    },
    error,
  );

/** @description 이메일 변경 인증 요청 중 다른 user가 사용 중인 이메일을 요청함 */
export const CERTIFICATION_011 = (error?: Error) =>
  new FeatureError(
    {
      title: T('certification.error.mobile.011_title'),
      message: T('certification.error.mobile.011_message'),
      code: 'CERTIFICATION_011',
    },
    error,
  );
